 
<script>
import { Component, Vue,Prop, Watch } from "vue-property-decorator";
import * as d3 from 'd3'
import { DateString } from "@/DateString"

@Component({ components: {  } })
export default class ChartVue extends Vue {
  key=0;
    @Prop(Array) input;
    @Prop(Number) chours;

    dat=[]
    maxx=0;
    minDt=null;
    maxDt=null;
    maxy=0;
    hours=[]
    przerwy=[]
    title=""

    async mounted() {
        Vue.nextTick(() => {
          this.retrieveGraph(this.datax)
        });
        this.key++;
    }

  add_ms(date, milliseconds) {
    const result = new Date(date);
    result.setMilliseconds(result.getMilliseconds() + milliseconds);
    return result;
  }

    prepare() {
        if (!this.input) return []
        let pp = []
        for (let i=0;i<this.input.length;i++) {
            //console.log("input",i,this.input[i])
            let d= this.input[i]
            //.replace(",",""))
            //console.log(d)
            if (!d.factor) d.factor=1;
            /*
            d.v1/=d.factor
            d.v2/=d.factor
            */

            d.date=new Date(d.utcdate)
            
            if (i==this.input.length-1) {
              d.date2=this.add_ms(d.date, d.ms2 - d.ms1)
            } else {
              d.date2=new Date(this.input[i+1].utcdate)
            }
            
            d.datestr1=d.date.toISOString()
            d.datestr2=d.date2.toISOString()


            if (!this.maxDt) this.maxDt=d.date;
            if (d.date>this.maxDt) this.maxDt=d.date;


            if (!this.minDt) this.minDt=d.date;
            if (d.date<this.minDt) this.minDt=d.date;
            this.minDt = new Date(this.maxDt);
            this.minDt.setHours( d.date.getHours() - this.chours );
            d.setup=0;
            if (d.v1/d.factor<d.velocity_mbs) d.setup=1;
            if (d.ms2>this.maxx) this.maxx=d.ms2;
            if (d.v1>this.maxy) this.maxy=d.v1;
            if (d.v2>this.maxy) this.maxy=d.v2;
            pp.push(d)   
        }

        let h=new Date(this.minDt);
        h.setMinutes(0,0);
        h.setHours(h.getHours()+1);

   while (h<=this.maxDt ) {
            const dd = new Date(h)
            this.hours.push(dd);
            console.log(dd.toISOString())
            h.setHours(h.getHours()+1);
            if (dd.toISOString().substring(11,16)=="09:00" || 
                dd.toISOString().substring(11,16)=="17:00" || 
                dd.toISOString().substring(11,16)=="01:00" ) {
              const br1=new Date(dd)
              const br2=new Date(dd)
              br2.setMinutes(br2.getMinutes()+30);
              this.przerwy.push([br1, br2])
            }
        }
      console.dir(this.przerwy)
       // { ms1: 430243, ms2: 511029, v1: 201, v2: 203, setup: 0, zlecenie: "4/12345/2022", user: "JACEK MALCZEWSKI", maszyna: "JURMET_2", factor: "3.15", date: "2022-06-03T10:05:53.195Z" }
        //console.log("***** maxx",this.maxx)
        //console.log("***** maxy",this.maxy)
        this.dat=pp;
    }



    

  
 retrieveGraph() {
      let margin = ({top: 30, right: 30, bottom: 70, left: 60});
      let width = 1000 - margin.left - margin.right;
      let height = 500 - margin.top - margin.bottom;
      
      this.prepare();

      const svg = d3.select(this.$refs.example).
        append("svg").
        attr("fill", "black").
        attr("width", width + margin.left + margin.right).
        attr("height", height + margin.top + margin.bottom).
        append("g").
        attr("transform", `translate( ${margin.left} , ${margin.top} )`)

      const maxx=this.maxx;

      var scalex = d3.scaleTime()
          .domain([this.minDt, this.maxDt])
          .range([0, width]);

      //const maxy=this.maxy;
      const maxy=120;
      const scaley = d3.scaleLinear().
        domain([0, maxy]).
        range([ height, 0]);


      svg.append("g").
        attr("transform", "translate(0," + height + ")").
        call(d3.axisBottom(scalex).ticks(this.hours.length).tickFormat(function(d) { return  d.toISOString().substring(11,16)}))

      svg.append("g").call(d3.axisLeft(scaley));

  console.log("przerwy",this.przerwy.length, this.przerwy[0])



    svg.selectAll("polygon")
    .data(this.hours)
    .enter()
    .append("polygon")
      .attr("stroke", "blue")
      .attr("fill", (d) => { let color="blue"; return color;})
      .attr("fill-opacity", 0.1)
      .attr("stroke-width", 1)
      .attr("stroke-opacity", 0.5)
      .attr("points",function(d) { 
              let p = ""
              p += scalex(d)+","+scaley(0)  + " "
              p += scalex(d)+","+scaley(maxy)   + " "
              p += scalex(d)+","+scaley(maxy)   + " "
              p += scalex(d)+","+scaley(0)  +" "
              p += scalex(d)+","+scaley(0)
              return p;
      })
    .text((d) => `${d.datestr1}   ${d.datestr2} ${d.zlecenie}  v= ${d.v2} operator: ${d.user} ${d.maszyna} factor ${d.factor}`);

  svg.selectAll("polygon")
    .data(this.przerwy)
    .enter()
    .append("polygon")
      .attr("stroke", "gray")
      .attr("fill", "gray")
      .attr("fill-opacity", 0.1)
      .attr("stroke-width", 1)
      .attr("stroke-opacity", 0.2)

      .attr("points",function(d) { 
              let p = ""
              p += scalex(d[0])+","+scaley(0)  + " "
              p += scalex(d[0])+","+scaley(maxy)   + " "
              p += scalex(d[1])+","+scaley(maxy)   + " "
              p += scalex(d[1])+","+scaley(0)  +" "
              p += scalex(d[0])+","+scaley(0)
              return p;
      })

  var div = d3.select("body").append("div")	
    .attr("class", "tooltip")				
    .style("opacity", 0);

    svg.selectAll("polygon")
    .data(this.dat)
    .enter()
    .append("polygon")
     .attr("stroke", (d) => { let color="rgb(26, 116, 56)"; if (d.setup) color="rgb(150, 35, 0)"; return color;})
      .attr("fill", (d) => { let color="rgb(26, 116, 56)"; if (d.setup) color="rgb(150, 35, 0)"; return color;})
      .attr("fill-opacity", 0.4)
      .attr("stroke-opacity", 0.5)
      .attr("stroke-width", (d) => { let w=1; if (d.setup) w=2; return w;})
      .attr("points",function(d) { 
              
              let p = ""
       

              p += scalex(d.date)+","+scaley(0)  + " "
              p += scalex(d.date)+","+scaley(d.v2/d.factor)   + " "
              p += scalex(d.date2)+","+scaley(d.v1/d.factor)   + " "
              p += scalex(d.date2)+","+scaley(0)  +" "
              p += scalex(d.date)+","+scaley(0)
              return p;
      })
  

  }
}

</script>

<template>
    
  <div v-if="key"  :key="key" >
    {{title}}
    <div class="chartdiv" ref="example"></div>
    
    
  </div>
</template>
 
 <style scoped lang="css">

 .chartdiv {
    border: 1px solid steelblue;
    display: block;
    height:500px;
    width:1000px;
    margin: 0 auto;
    fill: rgb(150, 35, 0);
    overflow-x: scroll;
    overflow-y: clip;

}


</style>